import { render, staticRenderFns } from "./changePriceToShare.vue?vue&type=template&id=74f90582&scoped=true"
import script from "./changePriceToShare.vue?vue&type=script&lang=js"
export * from "./changePriceToShare.vue?vue&type=script&lang=js"
import style0 from "./changePriceToShare.vue?vue&type=style&index=0&id=74f90582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f90582",
  null
  
)

export default component.exports